import { FC, useContext, useEffect, useState } from "react";
import styles from './postcardMenu.module.css';
import ImageContext from "../../services/ImageContext";
import textNav from '../../images/nav_text.png'
import { Button } from "@mui/material";

interface IPostcardMenu{
    croppedImages: string[];
    isButtonChoiceDisabled: boolean;
    getPostcard: () => void;
}

export const PostcardMenu: FC<IPostcardMenu> = ({isButtonChoiceDisabled, getPostcard, croppedImages}) => {
    const [choiceImg, setChoiceImg] = useState<number>(1);
    const imgContext = useContext(ImageContext);

    const [ isBtnGetPostcard, setIsBtnGetPostcard ] = useState<boolean>(false)
    const [ isLocalImages, setIsLocalImages ] = useState<boolean>(false)

    // Проверяем, что контекст не undefined
    if (!imgContext) {
        throw new Error("EnvelopeMenu must be used within an ImageProvider");
    }

    const { imgNumber, setImgNumber } = imgContext;

    const handleMouseEnter = (index: number) => {
        if (choiceImg === null) {
            setChoiceImg(index);
        }
    };

    const handleChoiceImg = (index: number) => {
        setChoiceImg(index);
        setImgNumber(index)
    };

    const handleGetPostcard = () => getPostcard()

    useEffect(() => {
        const storedImages = localStorage.getItem('croppedImages');
        if (storedImages && storedImages.length > 0 && croppedImages.length > 1) {
            setIsLocalImages(true)
        }
    }, [croppedImages]);

    
    const checkScreenWidth = () => {
        setIsBtnGetPostcard(window.innerWidth < 699);
    };

    useEffect(() => {
        checkScreenWidth();

        window.addEventListener('resize', checkScreenWidth);
        return () => {
            window.removeEventListener('resize', checkScreenWidth);
        };
    }, []);

    return (
        <div className={styles.menu}>
            <h3 className={styles.title}>Сколько человек будет на&nbsp;открытке</h3>
            <nav className={styles.imgNav}>
                <ul className={styles.imgList}>
                    <li className={styles.imgListItem}>
                        <button 
                            onClick={() => handleChoiceImg(1)}
                            onMouseEnter={() => handleMouseEnter(1)}
                            className={`${styles.btnImgChoiceOne} ${choiceImg === 1 ? styles.selectedBtn : ''}`}
                            type="button"
                            disabled={isButtonChoiceDisabled}
                        />
                    </li>
                    <li className={styles.imgListItem}>
                        <button                         
                            onClick={() => handleChoiceImg(2)}
                            onMouseEnter={() => handleMouseEnter(2)}
                            className={`${styles.btnImgChoiceTwo} ${choiceImg === 2 ? styles.selectedBtn : ''}`}
                            type="button"
                            disabled={isButtonChoiceDisabled}
                        />
                    </li>
                    <li className={styles.imgListItem}>
                        <button                        
                            onClick={() => handleChoiceImg(3)}
                            onMouseEnter={() => handleMouseEnter(3)}
                            className={`${styles.btnImgChoiceThree} ${choiceImg === 3 ? styles.selectedBtn : ''}`}
                            type="button"
                            disabled={isButtonChoiceDisabled}
                        />
                    </li>
                    <li className={styles.imgListItem}>
                        <button                        
                            onClick={() => handleChoiceImg(4)}
                            onMouseEnter={() => handleMouseEnter(4)}
                            className={`${styles.btnImgChoiceFour} ${choiceImg === 4 ? styles.selectedBtn : ''}`}
                            type="button"
                            disabled={isButtonChoiceDisabled}
                        />
                    </li>
                </ul>
            </nav>
            <Button
                sx={{
                    backgroundColor: '#74bb44',
                    border: '2px solid #FFF',
                    borderRadius: '10px',
                    width: '70%',
                    height: '60px',
                    alignSelf: 'center',
                }}
                disabled={croppedImages && croppedImages.length == imgNumber ? false : isLocalImages ? false : true}
                style={isBtnGetPostcard ? {display: 'none'} : {}}
                className={styles.btnCutImage} 
                variant="contained"
                onClick={handleGetPostcard}
            >
                Создать открытку
            </Button>
        </div>
    );
};
